import React, { ReactElement, useEffect } from 'react';
import {
  withAppInsightsTracking,
  appInsights
} from '@exxonmobil/uit-uda-ui-components-lib';

import styles from './Scheduling.module.scss';

const renderScheduling = () => {
  return (
    <div className={styles.page}>
      <h1>Scheduling</h1>
    </div>
  );
};

const SchedulingComponent = React.memo((): ReactElement => {
  useEffect(() => {
    document.title = 'AION // Scheduling';
    appInsights.trackPageView({ name: 'Scheduling' });
  }, []);

  return renderScheduling();
});

export const Scheduling = withAppInsightsTracking(SchedulingComponent);
